<template>
  <div
    class="ignore-playSourceContainer"
    :style="{
      width: setScaleSize(1920),
      height: `${getScreenHeight()}px`,
      paddingLeft: setScaleSize(64),
      paddingRight: setScaleSize(64),
    }"
  >
    <div
      class="header"
      :style="{
        fontSize: setScaleSize(56),
        paddingTop: setScaleSize(75),
        paddingBottom: setScaleSize(119),
      }"
    >
      {{ $t('播放列表') }}
    </div>
    <div class="ignore-playSource">
      <div
        v-for="(item, key) in sourceList"
        :key="item.id"
        class="ignore-sourceItem"
        @click="handleClick(item)"
        :style="{
          width: setScaleSize(780),
          height: setScaleSize(160),
          borderRadius: setScaleSize(32),
          paddingLeft: setScaleSize(66),
          paddingRight: setScaleSize(66),
          marginBottom: setScaleSize(40),
          marginLeft: key % 2 == 0 ? 0 : setScaleSize(200),
        }"
      >
        <img
          :src="require('@/assets/images/playVideo.png')"
          :style="{
            width: setScaleSize(52),
            height: setScaleSize(52),
          }"
        />
        <div
          class="ignore-itemName"
          :style="{
            height: setScaleSize(67),
            fontSize: setScaleSize(48),
            lineHeight: setScaleSize(67),
            marginLeft: setScaleSize(30),
          }"
        >
          {{ getName(item?.name) }}
        </div>
      </div>
    </div>

    <van-dialog
      v-model="show"
      :overlay="false"
      :showConfirmButton="false"
      :width="setScaleSize(302)"
      :height="setScaleSize(84)"
    >
      <div
        class="playSourceText"
        :style="{
          fontSize: setScaleSize(32),
          width: setScaleSize(302),
          height: setScaleSize(84),
          lineHeight: setScaleSize(84),
        }"
      >
        {{ $t('视频已播放') }}
      </div>
    </van-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import { Toast, Dialog } from 'vant'
import axios from 'axios'
import { scaleSize, screenHeight } from '@/utils/utils'

Vue.use(Toast)
Vue.use(Dialog)

Toast.setDefaultOptions({
  duration: 5000,
  className: 'cusToastStylePlaySource',
})
export default {
  name: 'PlaySource',
  components: {},
  data() {
    return {
      sourceList: [],
      show: false,
      timerId: null,
    }
  },
  methods: {
    async init() {
      try {
        const res = await axios.get('http://10.108.12.27:9095/file/get/all')
        if (res.status === 200) {
          this.sourceList = res?.data?.data
        }
      } catch (error) {
        console.log(error)
      }
    },
    async handleClick(item) {
      try {
        await axios.post('http://10.108.12.27:9095/play_config/update', [
          {
            fileId: item.id,
            orderId: 0,
          },
        ])
        this.timerId && clearTimeout(this.timerId)
        this.show = true
        this.timerId = setTimeout(() => {
          this.show = false
        }, 1.5 * 1000)
      } catch (error) {
        console.log(error)
      }
    },
    setScaleSize(v) {
      return scaleSize(v)
    },
    getScreenHeight() {
      return screenHeight
    },
    // 去掉文件的后缀
    getName(fileName) {
      if (!fileName) {
        return ''
      }
      const match = fileName.match(/(.+)\.[^.]+$/)
      const justFileName = match ? match[1] : fileName
      return justFileName
    },
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    this.timerId && clearInterval(this.timerId)
  },
}
</script>
<style lang="less" scoped>
.ignore-playSourceContainer {
  background: #181e25;
  display: flex;
  flex-direction: column;
  .header {
    font-family: AlibabaPuHuiTi_2_55_Regular;
    color: #ffffff;
    text-align: center;
  }
  .ignore-playSource {
    flex: 1;
    overflow-y: auto;

    .ignore-sourceItem {
      background: #2b3140;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      float: left;

      .ignore-itemName {
        font-family: AlibabaPuHuiTi_2_55_Regular;
        color: #ffffff;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        /*! autoprefixer: off */
        -webkit-box-orient: vertical;
        /* autoprefixer: on */
        -webkit-line-clamp: 1;
        word-break: break-all;
      }
    }
  }

  .ignore-playSource::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    /**/
  }
  .ignore-playSource::-webkit-scrollbar-track {
    background: rgb(239, 239, 239);
    border-radius: 2px;
  }
  .ignore-playSource::-webkit-scrollbar-thumb {
    background: #666666;
    border-radius: 10px;
  }
  .ignore-playSource::-webkit-scrollbar-thumb:hover {
    background: #333;
  }
  .ignore-playSource::-webkit-scrollbar-corner {
    background: #179a16;
  }

  .van-dialog {
    top: 19%;
    background: #5e6673;
    .playSourceText {
      text-align: center;
      color: #ffffff;
    }
  }
}
</style>
